import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { permissionActions } from "../slices/permission";
import { getErrorMessage } from "../../utils/errorUtils";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";
import { PermissionDto } from "../../shared/dtos/permission/PermissionDto";

export const getPermissions =
  () =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(permissionActions.setLoading());
    try {
      const { data } = await axiosInstance.get<ApiResponseDto<PermissionDto[]>>(
        "/permissions",
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(permissionActions.setItems(data.data));
      }
    } catch (error) {
      dispatch(permissionActions.setError(getErrorMessage(error)));
    }
  };
